// extracted by mini-css-extract-plugin
module.exports = {"root":"template-meeting-date_root__2sZb-"};